export function openDatePicker(input: HTMLInputElement): void {
  if (input.disabled || input.readOnly) return;
  try {
    input.showPicker?.();
  } catch {
    // Some browsers already open the picker as part of the same click.
  }
}
